import React, { useState, useEffect } from "react";
import "./iplbattle.css";
import useUserInfo from "../../../Hooks/useUserInfo";
import CricketGame from "./cricketGame";
import { ChooseIplTeamWithCard, IplMatchData } from "../../../apis/iplBattle";
import Swal from "sweetalert2";
import vs from "../../../assets/images/Vs.png";
import { logPageView } from "../../../components/analytics";
import { getTeamColorsByLeague, logoMap2, teamColors } from "../../../helpers/helpers";
import Iplwar from "./ipllanding";
import MatchScheduleList from "./matchsceduleList";


const SelectTeamWithCard = () => {
  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();
  const [selectedTeam, setSelectedTeam] = useState("");
  const [unSelectedTeam, setUnSelectedTeam] = useState("");
  const [selectedTeamId, setSelectTeamId] = useState(null);
  const [selectCard, setSelectCard] = useState("");
  const [unSelectedTeamId, setUnSelectedTeamId] = useState(null);
  const [showCardFlex, setShowCardFlex] = useState(true);
  const [IsCardOpen, setIsCardOpen] = useState(false);
  const TeamColors = teamColors;
  const LiveMatchTeam = watchScreen?.current_battle;
  const ChosenTeam = watchScreen?.chosen_team_ipl?.[0];

  const goToThePage = (component, name) => {
    updateUserInfo((prev) => {
      return {
        ...prev,
        ...{
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails?.currentComponent,
          lastComponentText: userDetails?.currentComponentText,
          centerCount: userDetails?.centerCount + 1,
        },
      };
    });
  };
  useEffect(() => {
    logPageView("UFW CARD PAGE", "UFW CARD PAGE");
  }, []);

  const handleTeamSelection = (team, team2, id, unSelectId) => {
    setIsCardOpen(true);
    setSelectedTeam(team);
    setUnSelectedTeam(team2);
    setSelectTeamId(id);
    setUnSelectedTeamId(unSelectId);
  };
  const CardsArray = [
    {
      id: 1,
      name: "FAV TEAM CARD",
      disable: false,
      image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/cardfav.png",
    },
    {
      id: 2,
      name: "HATED TEAM CARD",
      disable: false,
      image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/cardhatred.png",
    },
    {
      id: 3,
      name: "FRIENDLY",
      disable: false,
      image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/cardfrd.png",
    },
    {
      id: 4,
      name: "BAD FAN",
      disable: false,
      image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/cardbad.png",
    },
    {
      id: 5,
      name: "LIFE SAVER",
      disable: false,
      image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/cardlife.png",
    },
    {
      id: 6,
      name: "SUICIDE BOMMER",
      disable: false,
      image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/powercard.png",
    },
    {
      id: 7,
      name: "SABOTEUR CARD",
      disable: false,
      image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/saboteur.svg",
    },
    {
      id: 8,
      name: "TRAITOR CARD",
      disable: false,
      image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/traitor.svg",
    },
    {
      id: 9,
      name: "JOKER",
      disable: false,
      image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/joker.svg",
    },
  ];
  const FilterCardFirst =
    ChosenTeam?.favteamId == selectedTeamId
      ? CardsArray?.filter(
          (el) => el?.name == "FAV TEAM CARD" || el?.name == "LIFE SAVER" || el?.name=="TRAITOR CARD"||el?.name=="JOKER"||el?.name=="SABOTEUR CARD"
        )
      : ChosenTeam?.hatedteamId == selectedTeamId
      ? CardsArray?.filter(
          (el) => el?.name == "HATED TEAM CARD" || el?.name == "SUICIDE BOMMER"||el?.name=="JOKER"||el?.name=="SABOTEUR CARD"
        )
      : selectedTeamId !== ChosenTeam?.hatedteamId &&
        selectedTeamId !== ChosenTeam?.favteamId
      ? CardsArray?.filter(
          (el) => el?.name == "FRIENDLY" || el?.name == "BAD FAN"||el?.name=="JOKER"||el?.name=="SABOTEUR CARD"
        )
      : [];

  const SecondLineCards =
    ChosenTeam?.favteamId == unSelectedTeamId
      ? CardsArray?.filter(
          (el) => el?.name == "FAV TEAM CARD" || el?.name == "LIFE SAVER"
        )
      : ChosenTeam?.hatedteamId == unSelectedTeamId
      ? CardsArray?.filter(
          (el) => el?.name == "HATED TEAM CARD" || el?.name == "SUICIDE BOMMER"
        )
      : unSelectedTeamId !== ChosenTeam?.hatedteamId &&
        unSelectedTeamId !== ChosenTeam?.favteamId
      ? CardsArray?.filter(
          (el) => el?.name == "FRIENDLY" || el?.name == "BAD FAN"
        )
      : [];

  const HideDisabledList =
    selectedTeamId !== ChosenTeam?.hatedteamId &&
    selectedTeamId !== ChosenTeam?.favteamId &&
    unSelectedTeamId !== ChosenTeam?.hatedteamId &&
    unSelectedTeamId !== ChosenTeam?.favteamId;

  const handleSelectCard = (name) => {
    setSelectCard(name);
  };
  const handleGoBack = () => {
    setIsCardOpen(false);
    setSelectCard("");
  };
  var data = {
    battleId: LiveMatchTeam?._id,
    selectedCard: selectCard,
    selectedTeamId: selectedTeamId,
  };
  const [isLoading, setIsLoading] = useState(false);
  const getRandomCardName = () => {
    const filtered = FilterCardFirst?.filter((card) => card.name !== "JOKER");
    const randomCard = filtered[Math.floor(Math.random() * filtered.length)];
    return randomCard.name;
  };
  
  const handleSubmit = async (apidata) => {
    if (selectCard === "") {
      alert("Pick a card to Continue");
    } else {
      let finalCard = selectCard;
  
      if (selectCard === "JOKER") {
        finalCard = getRandomCardName(); // get a random card name
        await Swal.fire({
          title: "🎭 Joker Card!",
          text: `You have been randomly assigned: ${finalCard}`,
          icon: "info",
          confirmButtonText: "OK",
        });
        setSelectCard(finalCard); // update state if needed
      }
  
      try {
        setIsLoading(true);
  
        const response = await ChooseIplTeamWithCard({
          ...apidata,
          selectedCard: finalCard, // send the finalCard (could be Joker or another)
        });
  
        const ResultIpl = await IplMatchData(watchScreen?.cricketLeague);
  
        if (ResultIpl) {
          updatewatchScreenInfo((prev) => ({
            ...prev,
            currentBattleDetails: ResultIpl?.currentBattleDetails,
            chosenTeam: ResultIpl?.chosenTeam,
            current_battle: ResultIpl?.current_battle,
          }));
        } else {
          console.log("Api error");
        }
  
        if (response) {
          setIsLoading(false);
          goToThePage(Iplwar, "Iplwar");
        }
      } catch (error) {
        console.error("Error saving:", error);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };
  
  const CurrentBattleName1 = LiveMatchTeam?.teams?.[0]?.teamName;
  const CurrentBattleName2 = LiveMatchTeam?.teams?.[1]?.teamName;
  console.log(CurrentBattleName1, "CurrentBattleName1");



  const FavTeamBgColorFilter = getTeamColorsByLeague(CurrentBattleName1, watchScreen?.cricketLeague);
  const FavTeamBgColor = FavTeamBgColorFilter?.background;

  const HateTeamBgColorFilter = getTeamColorsByLeague(CurrentBattleName2, watchScreen?.cricketLeague);
  const HateTeamBgColor = HateTeamBgColorFilter?.background;

  const CloseFunc =()=>{
    goToThePage(MatchScheduleList,'MatchScheduleList') 
  }
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        pointerEvents: "fill",
      }}
    >
      <div className="spinning-animation-sv"></div>
      <div className="battle-content1">
        {!IsCardOpen ? (
          <>
            <div className="outline">
              <div className="content">
                <p className="choose-text text-uppercase">Choose Your Team!</p>
              </div>
            </div>
            <div className="characters-container">
              <div className="character red-character">
                <div className="team-1">
                  <img
                    src={LiveMatchTeam?.teams?.[0]?.teamLogo}
                    alt="CSK"
                    height={200}
                    className="select-char"
                  />
                </div>
                <h3
                  className="shiba-text text-uppercase"
                  style={{ background: FavTeamBgColor }}
                >
                  {LiveMatchTeam?.teams?.[0]?.teamName}
                </h3>

                <ul className="team-stats ">
                  <li
                    style={{
                      fontWeight: "bold",
                      borderBottom: `1px solid ${FavTeamBgColor} `,
                    }}
                  >
                    RANK
                    <span className="value">
                      {LiveMatchTeam?.teams?.[0]?.rank}
                    </span>
                  </li>
                  <li
                    style={{
                      fontWeight: "bold",
                      borderBottom: `1px solid ${FavTeamBgColor} `,
                    }}
                  >
                    WIN
                    <span className="value">
                      {LiveMatchTeam?.teams?.[0]?.winCount}
                    </span>
                  </li>
                  <li>
                    LOSE
                    <span className="value">
                      {LiveMatchTeam?.teams?.[0]?.lossCount}
                    </span>
                  </li>
                </ul>
                <button
                  className="team-fav-btn text-uppercase"
                  style={{
                    background: FavTeamBgColor,
                    border: `2px solid ${FavTeamBgColor}`,
                  }}
                  onClick={() =>
                    handleTeamSelection(
                      LiveMatchTeam?.teams?.[0]?.teamName,
                      LiveMatchTeam?.teams?.[1]?.teamName,
                      LiveMatchTeam?.teams?.[0]?.teamId,
                      LiveMatchTeam?.teams?.[1]?.teamId
                    )
                  }
                >
                  Choose Me
                </button>
              </div>

              {/* <img src={vs} className="vs-text" alt="VS" /> */}

              <div className="character green-character">
                <div className="team-2">
                  <img
                    // src={LiveMatchTeam?.teams?.[1]?.teamLogo}
                    src={
                 
                      LiveMatchTeam?.teams?.[1]?.teamLogo
                    }
                    alt="RCB"
                    className="select-char"
                  />
                </div>
                <h3
                  className="pepe-text text-uppercase"
                  style={{ background: HateTeamBgColor }}
                >
                  {LiveMatchTeam?.teams?.[1]?.teamName}
                </h3>
                <ul className="team-stats">
                  <li
                    style={{
                      fontWeight: "bold",
                      borderBottom: `1px solid ${HateTeamBgColor} `,
                    }}
                  >
                    RANK
                    <span className="value">
                      {LiveMatchTeam?.teams?.[1]?.rank}
                    </span>
                  </li>
                  <li
                    style={{
                      fontWeight: "bold",
                      borderBottom: `1px solid ${HateTeamBgColor} `,
                    }}
                  >
                    WIN
                    <span className="value">
                      {LiveMatchTeam?.teams?.[1]?.winCount}
                    </span>
                  </li>
                  <li>
                    LOSE
                    <span className="value">
                      {LiveMatchTeam?.teams?.[1]?.lossCount}
                    </span>
                  </li>
                </ul>
                <button
                  className="team-hate-btn text-uppercase"
                  style={{
                    background: HateTeamBgColor,
                    border: `2px solid ${HateTeamBgColor}`,
                  }}
                  onClick={() =>
                    handleTeamSelection(
                      LiveMatchTeam?.teams?.[1]?.teamName,
                      LiveMatchTeam?.teams?.[0]?.teamName,
                      LiveMatchTeam?.teams?.[1]?.teamId,
                      LiveMatchTeam?.teams?.[0]?.teamId
                    )
                  }
                >
                  Choose Me
                </button>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="outline">
              <div className="content">
                <p className="choose-text1 text-uppercase">
                  Boost Your Battle with Special Cards!
                </p>
              </div>
            </div>

            {showCardFlex ? (
              <>
                <div className="flex howworks-power">
                  <h6 className="">How Power cards work</h6>
                  <img
                    src="https://d1ccopf5cw1hft.cloudfront.net/s3data/ReferImg.png"
                    style={{ width: "15px", cursor: "pointer" }}
                    onClick={() => setShowCardFlex(!showCardFlex)}
                  />
                </div>

                <div className="characters-container">
                  <div className="character red-character">
                    <div className="card-flex">
                      {FilterCardFirst?.map((item, index) => {
                        return (
                          <>
                            <div
                              className="position-relative"
                              style={{
                                border:
                                  selectCard == item?.name
                                    ? "1px solid green"
                                    : "",
                              }}
                              onClick={() => handleSelectCard(item?.name)}
                            >
                              <img
                                src={item?.image}
                                style={{ width: "100%" }}
                              />
                              <h2 className="powercard-text ">{item?.name}</h2>
                            </div>
                          </>
                        );
                      })}
                      {/* {!HideDisabledList && (
                        <>
                          {SecondLineCards?.map((item, index) => {
                            return (
                              <>
                                <div
                                  className="position-relative"
                                  style={{
                                    opacity: 0.3,
                                    filter:
                                      "greyscale(100%) drop-shadow(0 0 5px rgba(128, 128, 128, 0.5))",
                                  }}
                                >
                                  <img
                                    src={item?.image}
                                    style={{ width: "100%" }}
                                  />
                                  <h2 className="powercard-text ">
                                    {item?.name}
                                  </h2>
                                </div>
                              </>
                            );
                          })}
                        </>
                      )} */}
                    </div>

                    <div className="card-btn">
                      <button
                        className="team-reselect text-uppercase"
                        onClick={handleGoBack}
                      >
                        Back to select
                      </button>
                      <button
                        className="team-select text-uppercase"
                        onClick={() => handleSubmit(data)}
                      >
                        {isLoading ? (
                          <div className="loader-spin">
                            <div className="spinner"></div>{" "}
                          </div>
                        ) : (
                          "Continue"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="card-info-container">
                  <div className="row flexcard">
                    <div className="col-8">
                      <h3 className="togglepower">How Power Cards Work</h3>
                    </div>
                    <div className="card-info">
                      {/* <p
                        className="text-uppercase"
                        style={{ color: "#668168" }}
                      >
                        If you score{" "}
                        <span className="colortxt">
                          {" "}
                          10 runs & 5 tap points{" "}
                        </span>
                      </p> */}
                      <ul>
                        {[
                          {
                            name: "Favourite Card",
                            image:
                              "https://d1ccopf5cw1hft.cloudfront.net/s3data/card4.png",
                            content:  "Runs go to your Like Team." ,

                          },
                          {
                            name: "Hatred Card",
                            image:
                              "https://d1ccopf5cw1hft.cloudfront.net/s3data/card3.png",
                              content: "Runs reduce your Dislike Team's score." ,
                          },
                          {
                            name: "Friendly Card",
                            image:
                              "https://d1ccopf5cw1hft.cloudfront.net/s3data/card6.png",
                            content:"Runs are split between your Like Team and the Selected Team.",
                          },
                          {
                            name: "Bad Fan Card",
                            image:
                              "https://d1ccopf5cw1hft.cloudfront.net/s3data/card2.png",
                            content: "Runs are split to reduce both the Dislike and Selected Team's scores.",
                          },
                          {
                            name: "Life Saver Card",
                            image:
                              "https://d1ccopf5cw1hft.cloudfront.net/s3data/card5.png",
                            content: " All your runs are used to boost your Like Team's score."
                          },
                          {
                            name: "Sooside Bommer Card",
                            image:
                              "https://d1ccopf5cw1hft.cloudfront.net/s3data/card1.png",
                            content: "All your runs are used to reduce your Dislike Team's score."
                          },
                          {
                            name: "Traitor Card",
                            image:
                              "https://d1ccopf5cw1hft.cloudfront.net/s3data/traitor-2.svg",
                            content: "Negative impact on your Like team."
                          },
                          {
                            name: "Saboteur Card",
                            image:
                              "https://d1ccopf5cw1hft.cloudfront.net/s3data/saboteur-2.svg",
                            content: "Distributes equal runs to all teams except the Dislike Team."
                          },
                          {
                            name: "Joker Card",
                            image:
                              "https://d1ccopf5cw1hft.cloudfront.net/s3data/joker-2.svg",
                            content: "Activates a random card."
                          },
                         
                        ].map((card, index) => (
                          <li key={index}>
                            <img src={card.image} style={{ width: "30%" }} />
                            <div>

                              <h6 className="cardtitle">{card.name}:</h6>
                   
                             {card?.content}
                            
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-btn">
                  <button
                    className="team-reselect text-uppercase"
                    onClick={() => setShowCardFlex(!showCardFlex)}
                  >
                    Got it
                  </button>
                </div>
              </>
            )}
          </>
        )}
      </div>
      {!IsCardOpen&&
      <button
          style={{
            background: "transparent",
            border: "none",
            height: "24px",
          }}
        >
          <img
            onClick={CloseFunc}
            src={"/Xicon.png"}
            className="cancel_button-sv"
          />
        </button>}
    </div>
  );
};

export default SelectTeamWithCard;
